
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ipfs/[ipfsHash]",
      function () {
        return require("private-next-pages/ipfs/[ipfsHash].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ipfs/[ipfsHash]"])
      });
    }
  